import { BaseIcon } from '../BaseIcon';
import type { SizedIconProps } from '../BaseIcon';
import { IconSize } from '../../../../enums';

export type FileIconProps = Omit<SizedIconProps, 'children'>;

export const FileIcon = ({ size = IconSize.Standard, ...props }: FileIconProps) => {
  const sizeInPixel = size === IconSize.Mini ? 9 : 12;

  return (
    <BaseIcon width={sizeInPixel} height={sizeInPixel} viewBox="0 0 9 12" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 1L4.25 0V4C4.25 4.55228 4.69772 5 5.25 5H9.25L8.25 4L5.25 4V1Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.83579 1H1.25L1.25 11H8.25V4.41421L4.83579 1ZM4.83579 0C5.101 0 5.35536 0.105357 5.54289 0.292893L8.95711 3.70711C9.14464 3.89464 9.25 4.149 9.25 4.41421V11C9.25 11.5523 8.80229 12 8.25 12H1.25C0.697715 12 0.25 11.5523 0.25 11V1C0.25 0.447715 0.697715 0 1.25 0H4.83579Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

FileIcon.displayName = 'FileIcon';
